import { request } from '/app/app/assets/js/utils/request.js'
import { parseAndReplace } from '/app/app/assets/js/utils/dom-parser.js'

export default (path, selector) => ({
  chooseJob(sourceJobId) {
    this.updateJob(sourceJobId)
    this.$dispatch('modal:confirm')
  },

  updateJob(sourceJobId) {
    request(path, 'POST', { source_job_id: sourceJobId })
      .then((response) => response.text())
      .then((html) => parseAndReplace(html, selector))
      .catch((error) => console.error(error))
  },
})
